import { useEffect } from "react";
import { useGetMeQuery } from "../services/myServer/auth";
import { useDispatch, useSelector } from "react-redux";
import { selectJwtToken, setAddToken, setEmail } from "../store/slices/global";
import { useNavigate } from "react-router-dom";

export const UserData = () => {
  const token = localStorage.getItem("authToken");
  const jwtToken = useSelector(selectJwtToken);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data, error, refetch } = useGetMeQuery(undefined, {
    skip: !token,
  });

  useEffect(() => {
    if (jwtToken) {
      refetch();
    }
  }, [refetch, jwtToken]);

  useEffect(() => {
    if (error) {
      localStorage.removeItem("authToken");
      navigate("/");
    }
  }, [error, navigate]);

  useEffect(() => {
    dispatch(setEmail(data?.email || ""));
    if (data?.card_trader_token) {
      dispatch(setAddToken(data.card_trader_token));
    }
  }, [data, dispatch, jwtToken]);

  return null;
};
